import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ProjectsFacade,
  SharedFacade,
  customDecode,
  customEncode,
  decrypt,
  encrypt,
} from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { ProjectPackMaterialListDataGridService } from './project-material-list-data-grid.service';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ViewportScroller } from '@angular/common';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { AccessPermissionService, CustomModalService } from '@piqet-angular/shared';
import { catchError, of, finalize, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BookmarkComponent } from 'libs/ui/src/lib/bookmark/bookmark.component';
@Component({
  selector: 'piqet-angular-project-material-list',
  templateUrl: './project-material-list.component.html',
  styleUrls: ['./project-material-list.component.scss'],
})
export class ProjectMaterialListComponent {
  columnDefs: ColDef[];
  costColumnDefs: ColDef[];
  activatedRouteProjectId: any;
  projectPackMaterialDataPayload: any;
  activatedRoute: any;
  currentRoute: any;
  gridName = 'Project Scenario Materila List';
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    bookmarkRenderer: BookmarkComponent,
  };
  searchData: any = '';
  sortColumnState: any;
  scenarioId: any;
  menuDataForRouting: any;
  nextIndex: any;
  nextRoute: any;
  navigationConfig: any;
  headerData = {
    materialName: 'Summary of materials',
  };
  event: any;
  packageScenarioId: any;
  eId: any;
  isHideSideBar = false;
  projectData: any;
  copyPackMaterial: Subscription;
  deletePackMaterial: Subscription;
  updateBookMark: Subscription;
  subscriptionInline!: Subscription;
  editMaterialSuccess!: Subscription;
  showEdit = false;

  constructor(
    private projectPackMaterialListDataGridService: ProjectPackMaterialListDataGridService,
    private sharedService: SharedService,
    private accessService: AccessPermissionService,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private router: Router,
    private projectsService: ProjectsService,
    private modal: CustomModalService,
    private toaster: ToastrService,
    private viewportScroller: ViewportScroller
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.currentRoute = url[7];

    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'];
      this.getProjectMaterialList();
    });

    this.columnDefs =
      this.projectPackMaterialListDataGridService.getPackMaterialProjectListsDataColumn();
    this.costColumnDefs =
      this.projectPackMaterialListDataGridService.getPackMaterialProjectListsCostDataColumn();
    this.projectPackMaterialDataPayload =
      this.projectPackMaterialListDataGridService.getPackMaterialProjectPayload(this.searchData);

    this.projectFacade.GetProjectPackMaterialList(
      this.projectPackMaterialDataPayload,
      this.scenarioId
    );
    this.sharedService.menuData$.subscribe((res: any) => {
      this.menuDataForRouting = res;
    });

    this.editMaterialSuccess =
      this.projectPackMaterialListDataGridService.editFillingSuccessData$.subscribe(async () => {
        this.getProjectMaterialList();
      });

    this.copyPackMaterial =
      this.projectPackMaterialListDataGridService.copyPackMaterialData$.subscribe(
        async (copyData: any) => {
          await this.openCopyPackMaterialModal(copyData[0], copyData[1], copyData[2]);
        }
      );

    this.deletePackMaterial =
      this.projectPackMaterialListDataGridService.deletePackMaterialData$.subscribe(
        async (deleteData: any) => {
          await this.deletePackMaterialData(deleteData[0]);
        }
      );

    this.updateBookMark = this.projectPackMaterialListDataGridService.updateBookMark$.subscribe(
      async (componentData: any) => {
        await this.updateBookMarkFunc(componentData);
      }
    );
  }

  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');
    this.subscriptionInline =
      this.projectPackMaterialListDataGridService.inlineEditingObservable$.subscribe(
        (inlineData: any) => {
          this.inlineDataEditing(inlineData);
        }
      );
  }

  updateBookMarkFunc(data: any) {
    this.projectsService
      .updateBookMark(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getProjectMaterialList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  triggerScroll(): void {
    this.sharedService.triggerScroll();
  }

  inlineDataEditing(payload: any) {
    this.projectsService
      .projectMaterialInlineEdit(payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getProjectMaterialList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  async addMatierialModal(scenarioId: any, id: any, isMaterial: any, label?: any) {
    const response = await this.projectsService.getAddEditPackMaterialModalAsync(
      scenarioId,
      id,
      isMaterial
    );
    this.modal.invoke('newAddProjectMaterial', {
      initialState: {
        newMyProjectsPackMaterial: response.data,
        label: label,
        addTransportScenarioColDef:
          this.projectPackMaterialListDataGridService.getTransportModalForManualLocationDataColumn(),
        distanceProcessColumnDef:
          this.projectPackMaterialListDataGridService.getTransportModalForManualDestinationDataColumn(),
        customTransportColumnDef:
          this.projectPackMaterialListDataGridService.getCustomTransportItemsList(),
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewMyProjectPackMaterialEvent.subscribe(
      (saveNewMyProjectPackMaterialEvent: any) => {
        this.addUpdatePackMaterial(saveNewMyProjectPackMaterialEvent);
      }
    );
  }

  addUpdatePackMaterial(data: any) {
    this.projectsService
      .addEditMyAllProjectPackMaterialData(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getProjectMaterialList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  openCopyPackMaterialModal(data: any, label: any, scenarioId: any) {
    this.modal.invoke('newCopyPackMaterial', {
      initialState: {
        projectName: data.name,
        modalLable: label,
        componentId: data.componentId,
      },
      class: 'modal-lg',
    });
    return of(
      this.modal.ref?.content.saveNewPackMaterialCopy.subscribe((data: any) => {
        this.copyPackMaterialData(data);
      })
    );
  }

  copyPackMaterialData(data: any) {
    this.projectsService
      .copyProjectPackMaterial(this.scenarioId, data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.getProjectMaterialList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  deletePackMaterialData(data: any) {
    this.projectsService
      .deleteProjectPackMaterialList(data.componentId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getProjectMaterialList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  editRecord(record: any) {
    this.projectFacade.inlineDataEditForProjectMaterial(
      record[0],
      record[1].scenarioId,
      this.activatedRoute
    );
  }

  getProjectMaterialList() {
    this.projectsService
      .getMyAllProjectPackMaterialList(this.scenarioId)
      .pipe(finalize(() => {}))
      .subscribe((res: any) => {
        this.projectData = res.data;
        this.navigationConfig = {
          scenarioId: this.scenarioId,
          packageScenarioId: this.packageScenarioId,
          eId: this.eId,
          activatedRouteProjectId: this.activatedRouteProjectId,
          activatedRoute: this.activatedRoute,
          isProjectLocked: this.projectData?.isLockProject,
          isProductPage: true,
        };
      });
  }

  moveToNextStep() {
    const valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${
      this.packageScenarioId
    }, "eId": ${this.eId}, "haveTour": ${true}}`;
    const encryptedValue = encrypt(valueToEncrypt);
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    this.router.navigate(
      [`projects/projects-setting/${customEncode(btoa(encodedValue))}/product-loss`],
      { queryParams: { param: encryptedValue } }
    );
  }

  onPrev(step: string) {
    const sId: any = localStorage.getItem('sId');
    const encodedParams = `{ "id": ${sId} }`;
    this.router.navigate(
      [
        `projects/projects-setting/${customEncode(
          btoa(this.activatedRouteProjectId)
        )}/scenario-configuration`,
      ],
      { queryParams: { param: encrypt(encodedParams) } }
    );
  }
  changeRowOrder(event: any) {
    if (event) {
      const formattedArray = event.map((item: any, index: number) => ({
        componentId: item.componentId,
        orderId: index + 1,
      }));
      this.projectsService.addUpdateMaterialOrder(formattedArray).subscribe(res => {
        if (res.messageType) {
          this.toaster.error(res.message);
        } else {
          this.sharedService.accessSideBarData(() => {});
          this.toaster.success(res.message);
        }
      });
    }
  }

  ngOnDestroy() {
    this.copyPackMaterial.unsubscribe();
    this.deletePackMaterial.unsubscribe();
    this.subscriptionInline.unsubscribe();
    this.updateBookMark.unsubscribe();
  }
}
